import React from "react";
import Navbar from "../Components/Navbar";
import { isMobile } from "react-device-detect";
import SmartAi from "../Components/SmartAi";
import Footer from "../Components/Footer";
import { motion } from "motion/react";
import Core from "../Components/Core";

const Elementary = () => {
  return (
    <div>
      <Navbar />

      {/* HERO SECTION */}
      <section className="bg-white pb-lg-6 pb-4 px-lg-6 px-0">
        <div className="container">
          <div className="row pt-lg-10 pt-6 pb-lg-6 px-lg-0">

            {/* TEXT CONTENT */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 mb-6 mb-lg-0"
            >
              <div className="text-center text-md-start">
                <div className="text-muted text-uppercase mb-2 fs-6">
                  Discovering Potential, Inspiring Futures
                </div>
                <div className="fs-m fw-semibold mb-2 text-dark">
                  Primary School (Elementary) Program
                </div>
              </div>

              <div
                className={`fs-4 text-dark ${
                  isMobile ? "px-4" : "text-justify"
                }`}
              >
                At Ebun Heritage Schools, our Primary School Program is
                designed to provide a nurturing, stimulating, and engaging
                learning environment for our young learners.
                <br />
                <br />
                We focus on building strong academic foundations while
                encouraging creativity, curiosity, and confidence. Through
                structured learning and interactive experiences, our pupils
                develop essential literacy, numeracy, and critical-thinking
                skills.
                <br />
                <br />
                Our experienced educators provide individualized attention,
                ensuring every child feels valued, supported, and inspired to
                excel.
              </div>
            </motion.div>

            {/* IMAGE 1 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 text-center"
            >
              <img
                src="../../assets/images/background/pry1.png"
                alt="Primary Program"
                width={500}
                className="img-fluid mb-lg-4"
              />
            </motion.div>

            {/* IMAGE 2 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 text-center mt-lg-n16"
            >
              <img
                src="../../assets/images/background/pry2.png"
                alt="Elementary Learning"
                width={500}
                className="img-fluid mb-lg-4"
              />
            </motion.div>

            {/* OFFER SECTION */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 mb-6 mb-lg-0 mt-lg-8 mt-4"
            >
              <div className="fs-t2 text-gray-800 fw-semibold mb-lg-4 mb-4 text-lg-start text-center">
                <span style={{ color: "#38a169" }}>★</span>{" "}
                We <u className="text-primary"><span className="text-dark-blue">Offer The Best.</span></u>
              </div>

              <div
                className={`fs-4 text-dark ${
                  isMobile ? "px-4" : "text-justify"
                }`}
              >
                Our curriculum promotes holistic development — academic,
                emotional, social, physical, and spiritual growth.
                <br />
                <br />
                We integrate interactive classroom instruction with music,
                arts, technology, and outdoor activities to create a balanced
                and enriching learning experience.
                <br />
                <br />
                Safety, discipline, and moral values remain central to our
                teaching philosophy, ensuring our pupils grow into responsible
                and confident individuals.
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="bg-back pt-lg-6 pt-8 pb-lg-6 pb-4 px-lg-6 px-0">
        <div className="container">

          {/* CONTACT CARD */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="px-lg-18 mt-lg-n14 mt-n8"
          >
            <div
              className="card shadow-lg bg-dark-blue p-4 p-lg-6"
              style={{ borderRadius: "30px" }}
            >
              <div className="d-lg-flex text-center align-items-center justify-content-center">
                <div>
                  <div className="fs-5 text-white">Get In Touch</div>
                  <div className="fs-3 text-white">
                    admin@ebunheritageschools.com
                  </div>
                </div>

                <div className="mx-4">
                <button className="btn btn-icon btn-white shadow-lg fw-semibold py-4 px-4 fs-5 rounded-circle">
                    OR
                </button>
                </div>

                <div>
                  <div className="fs-5 text-white">Call Us</div>
                  <div className="fs-3 text-white">
                  +234 906 216 8062
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* GOAL SECTION */}
          <div className="row align-items-center pt-lg-10 pt-6 pb-lg-6 px-lg-0">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 mb-6 mb-lg-0"
            >
              <div className="fs-t2 fw-semibold mb-4 text-lg-start text-center">
                <span style={{ color: "#38a169" }}>★</span>{" "}
                Our <u className="text-primary"><span className="text-dark-blue">Goal.</span></u>
              </div>

              <div
                className={`fs-4 text-dark ${
                  isMobile ? "px-4" : "text-justify"
                }`}
              >
                Our goal at Ebun Heritage Schools is to nurture every child’s
                God-given potential and guide them toward discovering their
                purpose.
                <br />
                <br />
                We are committed to academic excellence, character building,
                and spiritual growth within a safe and supportive environment.
                <br />
                <br />
                Through mentorship, innovation, and dedication, we prepare our
                pupils to become confident, disciplined, and globally minded
                leaders.
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 text-center"
            >
              <img
                src="../../assets/images/background/value.png"
                alt="Our Goal"
                width={500}
                className="img-fluid mb-lg-4"
              />
            </motion.div>
          </div>
        </div>
      </section>

      <Core />
      <Footer />
    </div>
  );
};

export default Elementary;
